var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDragDrop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#778699",
  fillRule: "nonzero",
  d: "M17 14.25a.75.75 0 0 1 .102 1.493L17 15.75H6a.75.75 0 0 1-.102-1.493L6 14.25zm0-5a.75.75 0 0 1 .102 1.493L17 10.75H6a.75.75 0 0 1-.102-1.493L6 9.25z"
})));
export default SvgIconDragDrop;